/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис управления настройками FTP
 */

/**
 * Сервис управления настройками FTP
 */
export class FtpServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод редактирования настроек FTP
   */
  EditFtp = (req: Pick<EditFtpRequestDto, "updateMask"> & { data: FtpRequestDto & fm.RequireAtLeastOne<FtpRequestDto> }, init?: RequestInit): Promise<EditFtpResponseDto> => {
    return fm.request<Pick<EditFtpRequestDto, "updateMask"> & { data: FtpRequestDto & fm.RequireAtLeastOne<FtpRequestDto> }, EditFtpResponseDto>(`${this.host}/device/api/v1/ftp`, { ...init, method: "PATCH", body: JSON.stringify(req.data, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения настроек FTP
   */
  GetFtp = (req?: GetFtpRequestDto, init?: RequestInit): Promise<GetFtpResponseDto> => {
    return fm.request<GetFtpRequestDto, GetFtpResponseDto>(`${this.host}/device/api/v1/ftp${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Создать бэкап и положить на FTP папку
   */
  PostFtpBackup = (req: PostFtpBackupRequestDto, init?: RequestInit): Promise<PostFtpBackupResponseDto> => {
    return fm.request<PostFtpBackupRequestDto, PostFtpBackupResponseDto>(`${this.host}/device/api/v1/ftp/backup`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Скачать бэкап из FTP папки и применить
   */
  PostFtpBackupApply = (req: PostFtpBackupApplyRequestDto, init?: RequestInit): Promise<PostFtpBackupApplyResponseDto> => {
    return fm.request<PostFtpBackupApplyRequestDto, PostFtpBackupApplyResponseDto>(`${this.host}/device/api/v1/ftp/backup/apply`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос редактирования настроек FTP
 */
export type EditFtpRequestDto = {
  /**
   * Настройки FTP
   */
  data: FtpRequestDto
  /**
   * Маска полей обновления
   */
  updateMask?: string | null
}
/**
 * Ответ на запрос редактирования настроек FTP
 */
export type EditFtpResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки FTP
   */
  readonly data: FtpResponseDto
  /**
   * Ошибка
   */
  readonly error: EditFtpResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type EditFtpResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type EditFtpResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Настройки FTP
 */
export type FtpRequestDto = {
  /**
   * Адрес FTP сервера.
   * Сетевой адрес и порт.
   * Пример: 192.168.0.1:21, ftp.acme.io:21
   */
  regServerAddress?: string
  /**
   * Логин
   */
  login?: string
  /**
   * Пароль.
   * Не возвращается с сервера.
   * TODO: в генерации сваггера не показывать INPUT_ONLY поля в ответах
   */
  password: string
}
/**
 * Настройки FTP
 */
export type FtpResponseDto = {
  /**
   * Адрес FTP сервера.
   * Сетевой адрес и порт.
   * Пример: 192.168.0.1:21, ftp.acme.io:21
   */
  regServerAddress: string
  /**
   * Логин
   */
  login: string
}
/**
 * Запрос получения настроек FTP
 */
export type GetFtpRequestDto = {
}
/**
 * Ответ на запрос получения настроек FTP
 */
export type GetFtpResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки FTP
   */
  readonly data: FtpResponseDto
}>
/**
 * Запрос применения бекапа
 */
export type PostFtpBackupApplyRequestDto = {
  /**
   * Имя FTP папки
   */
  ftpPath: string
  /**
   * Имя файла бекапа
   */
  fileName: string
  /**
   * Опции восстановления
   */
  restoreOptions?: string
}
/**
 * Ответ на запрос применения бекапа
 */
export type PostFtpBackupApplyResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostFtpBackupApplyResponseErrorDto
}>
/**
 * Ошибка запроса создания бекапа
 */
export type PostFtpBackupApplyResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса создания бекапа
 */
export type PostFtpBackupApplyResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос создания бекапа
 */
export type PostFtpBackupRequestDto = {
  /**
   * Имя FTP папки
   */
  ftpPath: string
  /**
   * Имя файла бекапа
   */
  fileName: string
  /**
   * Тип бекапа
   */
  backupType: string
}
/**
 * Ответ на запрос создания бекапа
 */
export type PostFtpBackupResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostFtpBackupResponseErrorDto
}>
/**
 * Ошибка запроса создания бекапа
 */
export type PostFtpBackupResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса создания бекапа
 */
export type PostFtpBackupResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос редактирования настроек FTP
   */
  "EditFtpRequest": {
    "kind": "class",
    "text": "Запрос редактирования настроек FTP",
    "fields": {
      /**
       * Настройки FTP
       */
      "data": {
        "type": "Ftp",
        "text": "Настройки FTP",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Маска полей обновления
       */
      "updateMask": {
        "type": "google.protobuf.FieldMask",
        "text": "Маска полей обновления",
      },
    },
  },
  /**
   * Ответ на запрос редактирования настроек FTP
   */
  "EditFtpResponse": {
    "kind": "class",
    "text": "Ответ на запрос редактирования настроек FTP",
    "fields": {
      /**
       * Настройки FTP
       */
      "data": {
        "type": "Ftp",
        "text": "Настройки FTP",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "EditFtpResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "EditFtpResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Настройки FTP
   */
  "Ftp": {
    "kind": "class",
    "text": "Настройки FTP",
    "fields": {
      /**
       * Адрес FTP сервера.
       * Сетевой адрес и порт.
       * Пример: 192.168.0.1:21, ftp.acme.io:21
       */
      "regServerAddress": {
        "type": "string",
        "text": "Адрес FTP сервера.\nСетевой адрес и порт.\nПример: 192.168.0.1:21, ftp.acme.io:21",
      },
      /**
       * Логин
       */
      "login": {
        "type": "string",
        "text": "Логин",
      },
      /**
       * Пароль.
       * Не возвращается с сервера.
       * TODO: в генерации сваггера не показывать INPUT_ONLY поля в ответах
       */
      "password": {
        "type": "string",
        "text": "Пароль.\nНе возвращается с сервера.\nTODO: в генерации сваггера не показывать INPUT_ONLY поля в ответах",
      },
    },
  },
  /**
   * Запрос получения настроек FTP
   */
  "GetFtpRequest": {
    "kind": "class",
    "text": "Запрос получения настроек FTP",
  },
  /**
   * Ответ на запрос получения настроек FTP
   */
  "GetFtpResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения настроек FTP",
    "fields": {
      /**
       * Настройки FTP
       */
      "data": {
        "type": "Ftp",
        "text": "Настройки FTP",
      },
    },
  },
  /**
   * Запрос применения бекапа
   */
  "PostFtpBackupApplyRequest": {
    "kind": "class",
    "text": "Запрос применения бекапа",
    "fields": {
      /**
       * Имя FTP папки
       */
      "ftpPath": {
        "type": "string",
        "text": "Имя FTP папки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Имя файла бекапа
       */
      "fileName": {
        "type": "string",
        "text": "Имя файла бекапа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Опции восстановления
       */
      "restoreOptions": {
        "type": "string",
        "text": "Опции восстановления",
      },
    },
  },
  /**
   * Ответ на запрос применения бекапа
   */
  "PostFtpBackupApplyResponse": {
    "kind": "class",
    "text": "Ответ на запрос применения бекапа",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostFtpBackupApplyResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса создания бекапа
   */
  "PostFtpBackupApplyResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса создания бекапа",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос создания бекапа
   */
  "PostFtpBackupRequest": {
    "kind": "class",
    "text": "Запрос создания бекапа",
    "fields": {
      /**
       * Имя FTP папки
       */
      "ftpPath": {
        "type": "string",
        "text": "Имя FTP папки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Имя файла бекапа
       */
      "fileName": {
        "type": "string",
        "text": "Имя файла бекапа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип бекапа
       */
      "backupType": {
        "type": "string",
        "text": "Тип бекапа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос создания бекапа
   */
  "PostFtpBackupResponse": {
    "kind": "class",
    "text": "Ответ на запрос создания бекапа",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostFtpBackupResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса создания бекапа
   */
  "PostFtpBackupResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса создания бекапа",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
}